"use client";

import { c as _c } from "react/compiler-runtime";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CarePlanStepStatus } from "@/types/care-plan";
import { useCarePlanContext } from "./care-plan";
import { ALLOWED_TRANSITIONS, STATUS_LABELS } from "./step-detail-helpers";
import { type PatientCarePlanStep, isPatientStep } from "./types";
export function StepStatusSelector() {
  const $ = _c(37);
  const {
    state: t0,
    actions: t1,
    config: t2
  } = useCarePlanContext();
  const {
    selectedStep
  } = t0;
  const {
    updateStep
  } = t1;
  const {
    readOnly,
    isCreating
  } = t2;
  if (!selectedStep || !isPatientStep(selectedStep)) {
    return null;
  }
  if (isCreating) {
    return null;
  }
  let T0;
  let T1;
  let t10;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== readOnly || $[1] !== selectedStep.id || $[2] !== selectedStep.status || $[3] !== updateStep) {
    const allowedTargets = ALLOWED_TRANSITIONS[selectedStep.status] ?? [];
    const isTerminal = allowedTargets.length === 0;
    t9 = "space-y-1";
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <Label>Status</Label>;
      $[14] = t10;
    } else {
      t10 = $[14];
    }
    T1 = Select;
    t5 = selectedStep.status;
    if ($[15] !== selectedStep.id || $[16] !== updateStep) {
      t6 = v => {
        const newStatus = v as CarePlanStepStatus;
        const updates = {
          status: newStatus
        };
        if (newStatus === CarePlanStepStatus.PENDING) {
          updates.eventId = undefined;
          updates.taskId = undefined;
        }
        updateStep(selectedStep.id, updates);
      };
      $[15] = selectedStep.id;
      $[16] = updateStep;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    t7 = readOnly || isTerminal;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <SelectTrigger><SelectValue /></SelectTrigger>;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    T0 = SelectContent;
    const t11 = STATUS_LABELS[selectedStep.status];
    if ($[19] !== selectedStep.status || $[20] !== t11) {
      t3 = <SelectItem value={selectedStep.status}>{t11}</SelectItem>;
      $[19] = selectedStep.status;
      $[20] = t11;
      $[21] = t3;
    } else {
      t3 = $[21];
    }
    t4 = allowedTargets.map(_temp);
    $[0] = readOnly;
    $[1] = selectedStep.id;
    $[2] = selectedStep.status;
    $[3] = updateStep;
    $[4] = T0;
    $[5] = T1;
    $[6] = t10;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    T0 = $[4];
    T1 = $[5];
    t10 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
    t9 = $[13];
  }
  let t11;
  if ($[22] !== T0 || $[23] !== t3 || $[24] !== t4) {
    t11 = <T0>{t3}{t4}</T0>;
    $[22] = T0;
    $[23] = t3;
    $[24] = t4;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== T1 || $[27] !== t11 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7 || $[31] !== t8) {
    t12 = <T1 value={t5} onValueChange={t6} disabled={t7}>{t8}{t11}</T1>;
    $[26] = T1;
    $[27] = t11;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t10 || $[34] !== t12 || $[35] !== t9) {
    t13 = <div className={t9}>{t10}{t12}</div>;
    $[33] = t10;
    $[34] = t12;
    $[35] = t9;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
}
function _temp(status) {
  return <SelectItem key={status} value={status}>{STATUS_LABELS[status]}</SelectItem>;
}